<template>
  <div class="print-wrapper">
    <div id="print" ref="print">
      <slot></slot>
    </div>
    <div id="print-swap" ref="printSwap" />
  </div>
</template>

<script>
import computedStyleToInlineStyle from 'computed-style-to-inline-style';
import $ from 'jquery';

export default {
  name: 'Print',
  setup(props, { root, refs }) {
    const print = async () => {
      const node = $(refs.print)[0].cloneNode(true);
      let children = $(node).children();
      const swap = $(refs.printSwap);

      swap.empty();
      swap.show();

      children.each(function appendChild() {
        const child = this;
        swap.append(child);
      });

      children = swap.children();

      children.each(function cssChild() {
        const child = this;

        computedStyleToInlineStyle(child, {
          recursive: true,
          properties: [
            'font-size', 'text-decoration', 'color',
            'font-weight', 'line-height', 'font-family',
            'display', 'position', 'float', 'clear',
            'text-transform', 'text-align', 'max-width',
            'min-width', 'max-height', 'min-height',
            '-webkit-box-pack', 'margin', 'padding',
            'margin-left', 'margin-right', 'margin-top',
            'margin-bottom', 'padding-left', 'padding-right',
            'padding-top', 'padding-bottom', 'top', 'left',
            'right', 'bottom', 'transform', 'width', 'height',
            'border', 'border-top', 'border-bottom', 'border-left',
            'border-right', 'border-radius', 'background-size',
            'border-bottom-left-radius', 'border-bottom-right-radius',
            'border-top-left-radius', 'border-top-right-radius',
            'border-color', 'border-width', 'border-top-color',
            'border-top-width', 'border-bottom-color',
            'border-bottom-width', 'border-left-color',
            'border-left-width', 'border-right-color',
            'border-right-width', 'border-style', 'border-top-style',
            'border-bottom-style', 'border-left-style',
            'border-right-style', 'border-spacing', 'border-collapse',
            'white-space', 'word-wrap',
            'list-style-type', 'box-sizing', 'background-position',
            'overflow', 'opacity', 'vertical-align',
            'background-color', 'z-index', 'overflow-wrap',
            '-webkit-hyphens', '-ms-hyphen', '-moz-hyphens',
            'hyphens', 'fill', 'page-break-after',
            'flex-wrap', '-webkit-flex-wrap', 'moz-flex-wrap', '-ms-flex-wrap',
            '-ms-box-pack', '-moz-box-pack', 'background-repeat'
          ]
        });
      });

      $(refs.printSwap).find('.page').css({
        border: 0
      });

      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <style>
            html,
            body {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
              margin: 0;
            }

            @page {
              size: A4;
              margin: 0;
              padding: 0;
            }
          </style>
        <head>
        <body>
          ${swap.html()}
        </body>
        </html>
      `;

      swap.hide();

      const printWindow = window.open('', '', 'width=1200, height=800');
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();

      swap.empty();
      root.$forceUpdate();
    };

    return {
      print
    };
  }
};
</script>


<style lang='scss' scoped>
@import "~@/assets/scss/colors";
.print-wrapper {
  background-color: $white;
  box-sizing: content-box;
  width: 21cm;
}

.print-swap {
  display: none;
}
</style>
